import { useCallback, useEffect, useState } from "react";
import { fetchTemplates, getApiError } from "./emailApi";

const sortByName = (list) =>
  [...list].sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { sensitivity: "base" }),
  );

const useEmailTemplates = (currentSession) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      setTemplates(sortByName(await fetchTemplates(currentSession)));
    } catch (e) {
      setError(getApiError(e, "Failed to load templates."));
    } finally {
      setLoading(false);
    }
  }, [currentSession]);

  useEffect(() => {
    reload();
  }, [reload]);

  const upsert = useCallback(
    (template) =>
      setTemplates((prev) =>
        sortByName([...prev.filter((t) => t.id !== template.id), template]),
      ),
    [],
  );

  const remove = useCallback(
    (id) => setTemplates((prev) => prev.filter((t) => t.id !== id)),
    [],
  );

  return { templates, loading, error, reload, upsert, remove };
};

export default useEmailTemplates;
